import {


  GET_ALL_CONTACT_TYPES,
  GET_ALL_CONTACT_TYPES_FAILURE,
  GET_ALL_CONTACT_TYPES_SUCCESS,

} from "./actionTypes";

export const getAllContactTypes = (payload) => {
  return {
    type: GET_ALL_CONTACT_TYPES,
    payload: payload,
  };
}

export const getAllContactTypesSuccess = (payload) => {
  return {
    type: GET_ALL_CONTACT_TYPES_SUCCESS,
    payload: payload,
  };
}

export const getAllContactTypesFailure = (error) => {
  return {
    type: GET_ALL_CONTACT_TYPES_FAILURE,
    payload: error,
  };
}
